<template>
  <div id="after-payment">
   Twój link wygasł
  </div>
</template>

<script>
export default {
  name: 'CanceledPaymentRedirect'
}
</script>
